export const LEAGUES = [
  { id: 'ncaa', name: 'NCAA' },
  { id: 'nfl', name: 'NFL' },
  { id: 'mlb', name: 'MLB' },
  { id: 'nba', name: 'NBA' },
];

const team = (id, league, name, primary, secondary) => ({ id, league, name, primary, secondary });

export const TEAMS = [
  // NFL — official brand colors
  team('nfl-ari', 'nfl', 'Arizona Cardinals', '#97233F', '#000000'),
  team('nfl-atl', 'nfl', 'Atlanta Falcons', '#A71930', '#000000'),
  team('nfl-bal', 'nfl', 'Baltimore Ravens', '#241773', '#9E7C0C'),
  team('nfl-buf', 'nfl', 'Buffalo Bills', '#00338D', '#C60C30'),
  team('nfl-car', 'nfl', 'Carolina Panthers', '#0085CA', '#101820'),
  team('nfl-chi', 'nfl', 'Chicago Bears', '#0B162A', '#C83803'),
  team('nfl-cin', 'nfl', 'Cincinnati Bengals', '#FB4F14', '#000000'),
  team('nfl-cle', 'nfl', 'Cleveland Browns', '#311D00', '#FF3C00'),
  team('nfl-dal', 'nfl', 'Dallas Cowboys', '#003594', '#869397'),
  team('nfl-den', 'nfl', 'Denver Broncos', '#FB4F14', '#002244'),
  team('nfl-det', 'nfl', 'Detroit Lions', '#0076B6', '#B0B7BC'),
  team('nfl-gb', 'nfl', 'Green Bay Packers', '#203731', '#FFB612'),
  team('nfl-hou', 'nfl', 'Houston Texans', '#03202F', '#A71930'),
  team('nfl-ind', 'nfl', 'Indianapolis Colts', '#002C5F', '#A2AAAD'),
  team('nfl-jax', 'nfl', 'Jacksonville Jaguars', '#006778', '#D7A22A'),
  team('nfl-kc', 'nfl', 'Kansas City Chiefs', '#E31837', '#FFB81C'),
  team('nfl-lv', 'nfl', 'Las Vegas Raiders', '#000000', '#A5ACAF'),
  team('nfl-lac', 'nfl', 'Los Angeles Chargers', '#0080C6', '#FFC20E'),
  team('nfl-lar', 'nfl', 'Los Angeles Rams', '#003594', '#FFA300'),
  team('nfl-mia', 'nfl', 'Miami Dolphins', '#008E97', '#FC4C02'),
  team('nfl-min', 'nfl', 'Minnesota Vikings', '#4F2683', '#FFC62F'),
  team('nfl-ne', 'nfl', 'New England Patriots', '#002244', '#C60C30'),
  team('nfl-no', 'nfl', 'New Orleans Saints', '#101820', '#D3BC8D'),
  team('nfl-nyg', 'nfl', 'New York Giants', '#0B2265', '#A71930'),
  team('nfl-nyj', 'nfl', 'New York Jets', '#125740', '#000000'),
  team('nfl-phi', 'nfl', 'Philadelphia Eagles', '#004C54', '#A5ACAF'),
  team('nfl-pit', 'nfl', 'Pittsburgh Steelers', '#101820', '#FFB612'),
  team('nfl-sf', 'nfl', 'San Francisco 49ers', '#AA0000', '#B3995D'),
  team('nfl-sea', 'nfl', 'Seattle Seahawks', '#002244', '#69BE28'),
  team('nfl-tb', 'nfl', 'Tampa Bay Buccaneers', '#D50A0A', '#34302B'),
  team('nfl-ten', 'nfl', 'Tennessee Titans', '#0C2340', '#4B92DB'),
  team('nfl-was', 'nfl', 'Washington Commanders', '#5A1414', '#FFB612'),

  // MLB — official brand colors
  team('mlb-ari', 'mlb', 'Arizona Diamondbacks', '#A71930', '#E3D4AD'),
  team('mlb-atl', 'mlb', 'Atlanta Braves', '#CE1141', '#13274F'),
  team('mlb-bal', 'mlb', 'Baltimore Orioles', '#DF4601', '#000000'),
  team('mlb-bos', 'mlb', 'Boston Red Sox', '#BD3039', '#0C2340'),
  team('mlb-chc', 'mlb', 'Chicago Cubs', '#0E3386', '#CC3433'),
  team('mlb-cws', 'mlb', 'Chicago White Sox', '#27251F', '#C4CED4'),
  team('mlb-cin', 'mlb', 'Cincinnati Reds', '#C6011F', '#000000'),
  team('mlb-cle', 'mlb', 'Cleveland Guardians', '#00385D', '#E31937'),
  team('mlb-col', 'mlb', 'Colorado Rockies', '#33006F', '#C4CED4'),
  team('mlb-det', 'mlb', 'Detroit Tigers', '#0C2340', '#FA4616'),
  team('mlb-hou', 'mlb', 'Houston Astros', '#002D62', '#EB6E1F'),
  team('mlb-kc', 'mlb', 'Kansas City Royals', '#004687', '#BD9B60'),
  team('mlb-laa', 'mlb', 'Los Angeles Angels', '#BA0021', '#003263'),
  team('mlb-lad', 'mlb', 'Los Angeles Dodgers', '#005A9C', '#EF3E42'),
  team('mlb-mia', 'mlb', 'Miami Marlins', '#00A3E0', '#EF3340'),
  team('mlb-mil', 'mlb', 'Milwaukee Brewers', '#12284B', '#FFC52F'),
  team('mlb-min', 'mlb', 'Minnesota Twins', '#002B5C', '#D31145'),
  team('mlb-nym', 'mlb', 'New York Mets', '#002D72', '#FF5910'),
  team('mlb-nyy', 'mlb', 'New York Yankees', '#003087', '#E4002C'),
  team('mlb-oak', 'mlb', 'Athletics', '#003831', '#EFB21E'),
  team('mlb-phi', 'mlb', 'Philadelphia Phillies', '#E81828', '#002D72'),
  team('mlb-pit', 'mlb', 'Pittsburgh Pirates', '#27251F', '#FDB827'),
  team('mlb-sd', 'mlb', 'San Diego Padres', '#2F241D', '#FFC425'),
  team('mlb-sf', 'mlb', 'San Francisco Giants', '#FD5A1E', '#27251F'),
  team('mlb-sea', 'mlb', 'Seattle Mariners', '#0C2C56', '#005C5C'),
  team('mlb-stl', 'mlb', 'St. Louis Cardinals', '#C41E3A', '#0C2340'),
  team('mlb-tb', 'mlb', 'Tampa Bay Rays', '#092C5C', '#8FBCE6'),
  team('mlb-tex', 'mlb', 'Texas Rangers', '#003278', '#C0111F'),
  team('mlb-tor', 'mlb', 'Toronto Blue Jays', '#134A8E', '#1D2D5C'),
  team('mlb-wsh', 'mlb', 'Washington Nationals', '#AB0003', '#14225A'),

  // NBA — official brand colors
  team('nba-atl', 'nba', 'Atlanta Hawks', '#E03A3E', '#C1D32F'),
  team('nba-bos', 'nba', 'Boston Celtics', '#007A33', '#BA9653'),
  team('nba-bkn', 'nba', 'Brooklyn Nets', '#000000', '#FFFFFF'),
  team('nba-cha', 'nba', 'Charlotte Hornets', '#1D1160', '#00788C'),
  team('nba-chi', 'nba', 'Chicago Bulls', '#CE1141', '#000000'),
  team('nba-cle', 'nba', 'Cleveland Cavaliers', '#860038', '#FDBB30'),
  team('nba-dal', 'nba', 'Dallas Mavericks', '#00538C', '#002B5E'),
  team('nba-den', 'nba', 'Denver Nuggets', '#0E2240', '#FEC524'),
  team('nba-det', 'nba', 'Detroit Pistons', '#C8102E', '#1D42BA'),
  team('nba-gsw', 'nba', 'Golden State Warriors', '#1D428A', '#FFC72C'),
  team('nba-hou', 'nba', 'Houston Rockets', '#CE1141', '#000000'),
  team('nba-ind', 'nba', 'Indiana Pacers', '#002D62', '#FDBB30'),
  team('nba-lac', 'nba', 'LA Clippers', '#C8102E', '#1D428A'),
  team('nba-lal', 'nba', 'Los Angeles Lakers', '#552583', '#FDB927'),
  team('nba-mem', 'nba', 'Memphis Grizzlies', '#5D76A9', '#12173F'),
  team('nba-mia', 'nba', 'Miami Heat', '#98002E', '#F9A01B'),
  team('nba-mil', 'nba', 'Milwaukee Bucks', '#00471B', '#EEE1C6'),
  team('nba-min', 'nba', 'Minnesota Timberwolves', '#0C2340', '#236192'),
  team('nba-nop', 'nba', 'New Orleans Pelicans', '#0C2340', '#C8102E'),
  team('nba-nyk', 'nba', 'New York Knicks', '#006BB6', '#F58426'),
  team('nba-okc', 'nba', 'Oklahoma City Thunder', '#007AC1', '#EF3B24'),
  team('nba-orl', 'nba', 'Orlando Magic', '#0077C0', '#C4CED4'),
  team('nba-phi', 'nba', 'Philadelphia 76ers', '#006BB6', '#ED174C'),
  team('nba-phx', 'nba', 'Phoenix Suns', '#1D1160', '#E56020'),
  team('nba-por', 'nba', 'Portland Trail Blazers', '#E03A3E', '#000000'),
  team('nba-sac', 'nba', 'Sacramento Kings', '#5A2D81', '#63727A'),
  team('nba-sas', 'nba', 'San Antonio Spurs', '#C4CED4', '#000000'),
  team('nba-tor', 'nba', 'Toronto Raptors', '#CE1141', '#000000'),
  team('nba-uta', 'nba', 'Utah Jazz', '#002B5C', '#00471B'),
  team('nba-was', 'nba', 'Washington Wizards', '#002B5C', '#E31837'),

  // NCAA — official school colors (major programs)
  team('ncaa-alabama', 'ncaa', 'Alabama Crimson Tide', '#9E1B32', '#828A8F'),
  team('ncaa-arizona', 'ncaa', 'Arizona Wildcats', '#CC0033', '#003366'),
  team('ncaa-arizonast', 'ncaa', 'Arizona State Sun Devils', '#8C1D40', '#FFC627'),
  team('ncaa-arkansas', 'ncaa', 'Arkansas Razorbacks', '#9D2235', '#FFFFFF'),
  team('ncaa-army', 'ncaa', 'Army Black Knights', '#D4BF91', '#000000'),
  team('ncaa-auburn', 'ncaa', 'Auburn Tigers', '#0C2340', '#E87722'),
  team('ncaa-baylor', 'ncaa', 'Baylor Bears', '#154734', '#FFB81C'),
  team('ncaa-boisestate', 'ncaa', 'Boise State Broncos', '#0033A0', '#D64309'),
  team('ncaa-bostoncollege', 'ncaa', 'Boston College Eagles', '#8A100B', '#B29D6C'),
  team('ncaa-byu', 'ncaa', 'BYU Cougars', '#002E5D', '#FFFFFF'),
  team('ncaa-cal', 'ncaa', 'California Golden Bears', '#003262', '#FDB515'),
  team('ncaa-cincinnati', 'ncaa', 'Cincinnati Bearcats', '#E00122', '#000000'),
  team('ncaa-clemson', 'ncaa', 'Clemson Tigers', '#F56600', '#522D80'),
  team('ncaa-colorado', 'ncaa', 'Colorado Buffaloes', '#CFB87C', '#000000'),
  team('ncaa-duke', 'ncaa', 'Duke Blue Devils', '#003087', '#FFFFFF'),
  team('ncaa-florida', 'ncaa', 'Florida Gators', '#0021A5', '#FA4616'),
  team('ncaa-floridast', 'ncaa', 'Florida State Seminoles', '#782F40', '#CEB888'),
  team('ncaa-georgia', 'ncaa', 'Georgia Bulldogs', '#BA0C2F', '#000000'),
  team('ncaa-georgiatech', 'ncaa', 'Georgia Tech Yellow Jackets', '#B3A369', '#003057'),
  team('ncaa-houston', 'ncaa', 'Houston Cougars', '#C8102E', '#76232F'),
  team('ncaa-illinois', 'ncaa', 'Illinois Fighting Illini', '#13294B', '#E84A27'),
  team('ncaa-indiana', 'ncaa', 'Indiana Hoosiers', '#990000', '#EEEDEB'),
  team('ncaa-iowa', 'ncaa', 'Iowa Hawkeyes', '#FFCD00', '#000000'),
  team('ncaa-iowast', 'ncaa', 'Iowa State Cyclones', '#C8102E', '#F1BE48'),
  team('ncaa-kansas', 'ncaa', 'Kansas Jayhawks', '#0051BA', '#E8000D'),
  team('ncaa-kansasst', 'ncaa', 'Kansas State Wildcats', '#512888', '#D1D1D1'),
  team('ncaa-kentucky', 'ncaa', 'Kentucky Wildcats', '#0033A0', '#FFFFFF'),
  team('ncaa-louisville', 'ncaa', 'Louisville Cardinals', '#AD0000', '#000000'),
  team('ncaa-lsu', 'ncaa', 'LSU Tigers', '#461D7C', '#FDD023'),
  team('ncaa-maryland', 'ncaa', 'Maryland Terrapins', '#E03A3E', '#FFD520'),
  team('ncaa-miami', 'ncaa', 'Miami Hurricanes', '#F47321', '#005030'),
  team('ncaa-michigan', 'ncaa', 'Michigan Wolverines', '#00274C', '#FFCB05'),
  team('ncaa-michiganst', 'ncaa', 'Michigan State Spartans', '#18453B', '#FFFFFF'),
  team('ncaa-minnesota', 'ncaa', 'Minnesota Golden Gophers', '#7A0019', '#FFCC33'),
  team('ncaa-missst', 'ncaa', 'Mississippi State Bulldogs', '#660000', '#FFFFFF'),
  team('ncaa-missouri', 'ncaa', 'Missouri Tigers', '#F1B82D', '#000000'),
  team('ncaa-navy', 'ncaa', 'Navy Midshipmen', '#00205B', '#C5B783'),
  team('ncaa-nebraska', 'ncaa', 'Nebraska Cornhuskers', '#E41C38', '#FFFFFF'),
  team('ncaa-northcarolina', 'ncaa', 'North Carolina Tar Heels', '#7BAFD4', '#13294B'),
  team('ncaa-ncstate', 'ncaa', 'NC State Wolfpack', '#CC0000', '#000000'),
  team('ncaa-northwestern', 'ncaa', 'Northwestern Wildcats', '#4E2A84', '#FFFFFF'),
  team('ncaa-notredame', 'ncaa', 'Notre Dame Fighting Irish', '#0C2340', '#C99700'),
  team('ncaa-ohiost', 'ncaa', 'Ohio State Buckeyes', '#BB0000', '#666666'),
  team('ncaa-oklahoma', 'ncaa', 'Oklahoma Sooners', '#841617', '#FDF9D8'),
  team('ncaa-oklahomast', 'ncaa', 'Oklahoma State Cowboys', '#FF7300', '#000000'),
  team('ncaa-olemiss', 'ncaa', 'Ole Miss Rebels', '#14213D', '#CE1126'),
  team('ncaa-oregon', 'ncaa', 'Oregon Ducks', '#154733', '#FEE123'),
  team('ncaa-oregonst', 'ncaa', 'Oregon State Beavers', '#DC4405', '#000000'),
  team('ncaa-pennst', 'ncaa', 'Penn State Nittany Lions', '#041E42', '#FFFFFF'),
  team('ncaa-pitt', 'ncaa', 'Pittsburgh Panthers', '#003594', '#FFB81C'),
  team('ncaa-purdue', 'ncaa', 'Purdue Boilermakers', '#CEB888', '#000000'),
  team('ncaa-rutgers', 'ncaa', 'Rutgers Scarlet Knights', '#CC0033', '#5F6A72'),
  team('ncaa-southcarolina', 'ncaa', 'South Carolina Gamecocks', '#73000A', '#000000'),
  team('ncaa-stanford', 'ncaa', 'Stanford Cardinal', '#8C1515', '#FFFFFF'),
  team('ncaa-syracuse', 'ncaa', 'Syracuse Orange', '#F76900', '#000E54'),
  team('ncaa-tcu', 'ncaa', 'TCU Horned Frogs', '#4D1979', '#A3A9AC'),
  team('ncaa-tennessee', 'ncaa', 'Tennessee Volunteers', '#FF8200', '#FFFFFF'),
  team('ncaa-texas', 'ncaa', 'Texas Longhorns', '#BF5700', '#333F48'),
  team('ncaa-texasam', 'ncaa', 'Texas A&M Aggies', '#500000', '#FFFFFF'),
  team('ncaa-texastech', 'ncaa', 'Texas Tech Red Raiders', '#CC0000', '#000000'),
  team('ncaa-ucla', 'ncaa', 'UCLA Bruins', '#2D68C4', '#F2A900'),
  team('ncaa-usc', 'ncaa', 'USC Trojans', '#990000', '#FFC72C'),
  team('ncaa-utah', 'ncaa', 'Utah Utes', '#CC0000', '#808080'),
  team('ncaa-vanderbilt', 'ncaa', 'Vanderbilt Commodores', '#866D4B', '#000000'),
  team('ncaa-virginia', 'ncaa', 'Virginia Cavaliers', '#232D4B', '#F84C1E'),
  team('ncaa-virginiatech', 'ncaa', 'Virginia Tech Hokies', '#630031', '#CF4420'),
  team('ncaa-wake', 'ncaa', 'Wake Forest Demon Deacons', '#9E7E38', '#000000'),
  team('ncaa-washington', 'ncaa', 'Washington Huskies', '#4B2E83', '#B7A57A'),
  team('ncaa-washingtonst', 'ncaa', 'Washington State Cougars', '#981E32', '#5E6A71'),
  team('ncaa-westvirginia', 'ncaa', 'West Virginia Mountaineers', '#002855', '#EAAA00'),
  team('ncaa-wisconsin', 'ncaa', 'Wisconsin Badgers', '#C5050C', '#FFFFFF'),
];

export const getTeamById = (id) => TEAMS.find((item) => item.id === id) || null;

export const getTeamsByLeague = (league) => TEAMS.filter((item) => item.league === league);

export const searchTeams = (league, query) => {
  const list = getTeamsByLeague(league);
  const needle = (query || '').trim().toLowerCase();
  if (!needle) return list;
  return list.filter((item) => item.name.toLowerCase().includes(needle));
};
